module.exports = __webpack_public_path__ + "static/img/ddhzyk-img3.829ee867.jpg";